module.exports = __webpack_public_path__ + "static/img/Tormenta Matte.1a91213.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Tormenta Matte.jpg
// module id = rqdq
// module chunks = 0